export default __webpack_public_path__ + "static/media/lutzen-cutout.2ad9ac3f.png";